import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { PageClientSideFilters } from "@ryde/layout";

import { JourneyCrudRoutes } from "./crud";

export const JourneysPage: FC = () => {
  return (
    <PageContextWrapper entity="journey">
      <PageClientSideFilters />
      <JourneyCrudRoutes />
    </PageContextWrapper>
  );
};
